<template>
  <div id="salesforce-auth" class="salesforce-login">
    <div class="center-container">
      <div class="input-container">
        <div class="logo">
          <main-logo
            width="121px"
            height="40px"
          />
        </div>
        <validation-observer
          ref="form"
        >
          <form class="login-form" novalidate>
            <validation-provider
              ref="test_email_provider"
              v-slot="{ errors, touched, pristine, valid, invalid, validated }"
              name="email"
              rules="required|email"
              class="email-validation-provider"
            >
              <input
                ref="test_email"
                v-model="email"
                type="email"
                placeholder="Email"
                class="form-control email-input"
                :class="{'is-invalid': (invalid && touched) || (pristine && validated && invalid)}"
                name="test_email"
              >
            </validation-provider>
            <base-button
              id="salesforce-login-button"
              class="login-button"
              inverse
              @click="loginHandler"
            >
              Login
            </base-button>
            <div v-if="errors.length > 0">
              <div
                v-for="(error, index) in errors"
                :key="`email_errors_${index}`"
              >
                <div>
                  {{ error }}
                </div>
              </div>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { API_ROOT } from '../../config';
import api from '../../_api';

export default {
  name: 'SalesforceOauthLogin',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      errors: [],
      email: null,
      clientId: null,
      redirectURI: new URL('/salesforce/oauth_callback', document.baseURI).href,
      responseType: 'code',
      salesforceLoginUrl: 'https://login.salesforce.com/services/oauth2/authorize',
    };
  },
  methods: {
    loginHandler() {
      this.errors = [];
      api.get(`${API_ROOT}/salesforce/client_id/email/${encodeURIComponent(this.email)}`).then((r) => {
        this.clientId = r.data.client_id;
        window.open(
          `${this.salesforceLoginUrl}?`
          + `client_id=${this.clientId}&`
          + `redirect_uri=${this.redirectURI}&`
          + `response_type=${this.responseType}&`
          + `state=${encodeURIComponent(this.email)}`,
          '__oauth__',
        );
      }).catch((error) => {
        this.errors.push(error);
      });
    },
  },
};
</script>

<style lang="scss">
.salesforce-login {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #F2F1EE;
}

.center-container{
  display: flex;
  flex-direction:column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
}

.email-validation-provider {
  width: 100%;
}

.input-container{
  width: 31.25rem;
  margin: 0 1rem;
  background-color: #fff;
  border-radius: 5px;
  padding: 3.75rem 4.5rem;

  .email-input {
    margin-bottom: 2.25rem;
    width: 100%;
  }

  @media (max-width: map-get($breakpoints, 'md')) {
    width: 25rem;
    padding: 3rem 3.5rem;
  }

  @media (max-width: 28.125em) {
    width: 22rem;
    padding: 2.5rem 3rem;
  }
}

.logo {
  margin-bottom: 2.25rem;
  display: flex;
  justify-content: center;
}

.login-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-button {
  width: 7.8rem;
  height: 2rem;
  display: flex;
  justify-content: center;
}
</style>
